import Chef from './Chef'
import './Chef.css'
import './background.css'

export default Chef



// WEBPACK FOOTER //
// ./src/components/Chef/index.js